/**
 * Dashboard - Places
 */

'use strict';

var helper = require('../../misc/helpers');
var formImages = require('../formImages');

// Constructor
var FrontPlacesDashboard = function () {
    if (!$('body').hasClass('dashboard-places-create') && $('body').find('.place-edition').length < 1) {
        return;
    }
    
    this.hoverPictures();
    this.hoverTypeBlock();

    $(document).ready((function () {
        // Create or update?
        var id = parseInt($('#idPostEdited').val());
        if (id > 0) {
            this.isUpdate = true;
            this.idPlace = id;
        }

        formImages.addImages(this.maxImages, this.isUpdate);

        if (this.isUpdate) {
            formImages.manageImages();
        }

        this.uiInitForm();
        this.goToStage2();
        this.updateFormFromSubcategories();
        this.submitForm();
        this.dropdownCategories();
        this.addVideoChips();
        this.deleteVideoChips();
        this.deletePictures();
        this.prepareEdition();
    }).bind(this));
};

FrontPlacesDashboard.prototype = {
    isUpdate: false,
    idPlace: 0,
    maxImages: 12,
    lockAjaxForm: false,

    uiInitForm: function() {
        $('#create-place select').formSelect();
        $('#create-place .video-chips').chips();

        // International Telephone Input
        // translated in french with the help of @link https://github.com/harold-s/harold-s/tree/master/intl-tel-input-french-translation 
        var countryData = $.fn.intlTelInput.getCountryData();
        
        $.each(countryData, function(i, country) {
            country.name = helper.hashCountryDataTranslation[country.iso2];
        });

        $('.input-field .phone').each(function() {
            $(this).intlTelInput({
                autoPlaceholder: 'polite',
                utilsScript: comedien.assets + 'vendor/intl-tel-input/build/js/utils.js',
                initialCountry: 'ch',
                preferredCountries: ['ch', 'fr', 'be', 'de', 'it']
            });
        });

        // TinyMCE
        tinymce.init({
            selector: '.tinymce',
            plugins: 'lists advlist paste',
            toolbar: 'undo redo | bold italic | bullist numlist | link | removeformat paste | styleselect',
            style_formats: [
                {title: 'Titre', block: 'h2'},
                {title: 'Sous-titre', block: 'h3'},
                {title: 'Normal', block: 'p'}
            ],
            menubar: false,
            branding: false,
            paste_data_images: false,
            paste_as_text: true,
            setup: function (editor) {
                editor.on('init', function (e) {
                    // Update height of columns
                    $('main#content > .col').matchHeight();
                });
            }
        });
    },

    hoverTypeBlock: function() {
        $('#place-type .type').on({
            mouseenter: function () {
                $(this).parent().find('.type.hover').removeClass('hover');
                $(this).addClass('hover');

                $(this).parent().find('.type:not(.hover)').each(function () {
                    $(this).addClass('hover-other');
                });
            },
            mouseleave: function () {
                $(this).parent().find('.type:not(.hover)').removeClass('hover-other');
                $(this).parent().find('.type.hover').removeClass('hover');
            }
        });
    },

    hoverPictures: function() {
        $('#create-place .picture-content').on({
            mouseenter: function() {
                $(this).find('.hover-picture').removeClass('hidden');
            },
            mouseleave: function() {
                $(this).find('.hover-picture').addClass("hidden");
            }
        });
    },

    prepareEdition: function() {
        var form = $('#create-place');
        var type = form.find('[name=type]').val();
        var fakeSubmit = $('.section-actions .fake-submit');

        if (type.length > 0) {
            $('.stage-two').removeClass('hide-on-load');
            fakeSubmit.removeClass('disabled');

            if (type === 'individual') {
                $('.organization').addClass('hidden'); 
                $('.individual').removeClass('hidden');
                
                $('.individual').find('.required').prop('required', true);           

                form.find('[name=type]').val('individual');

            } else {
                $('.individual').addClass('hidden');
                $('.organization').removeClass('hidden');

                $('.organization').find('.required').prop('required', true);

                form.find('[name=type]').val('organization');
            } 
        }
        
        var formule = form.find('[name=formule]').val();
        if (formule.length > 0) {
            if (formule === 'simple') {
                $('.partner').addClass('hidden');
            } else {
                $('.partner').removeClass('hidden');
            } 
        }

        // Category
        var $selectCategory = $('select#category', form);

        var categoryValue = form.find('[name=categoryValue]').val();
        if (categoryValue.length > 0) {
            var categories = categoryValue.split(',');
            for (var key in categories) {
                $selectCategory.find('[value='+ categories[key] +']').prop('selected', true);
            }
            $selectCategory.formSelect();
        }

        // Subcategory
        
        var $selectSubCategory = $('select#subCategory', form);

        if ($selectCategory.val() != '') {

            var selectedValue = $selectCategory.val();
                
            // Remove all options
            $selectSubCategory.find('option').remove();
            $selectSubCategory.append($('<option>', {
                value: '',
                text : comedien.i18n.placesDropdownSubCategory,
                disabled: 'disabled',
                selected: 'selected',
            }));
            $selectSubCategory.append($('<option>', {
                value: '',
                text : comedien.i18n.placesDropdownAll
            }));

            // Inset new options
            $.each(places.subCategories, function (i, item) {
                if (selectedValue == item.parent_id) {
                    $selectSubCategory.append($('<option>', {
                        value: item.term_id,
                        text : item.name
                    }));
                }
            });

            $selectSubCategory.removeAttr('disabled');
            $selectSubCategory.formSelect('destroy');
            $selectSubCategory.formSelect();

            var subCategoryValue = form.find('[name=subCategoryValue]').val();
            if (subCategoryValue.length > 0) { 
                var subcategories = subCategoryValue.split(',');
                for (var key in subcategories) {
                    $selectSubCategory.find('[value='+ subcategories[key] +']').prop('selected', true);
                }
                $selectSubCategory.formSelect();
            }

        }

        // Initialize Textarea with Materialize (except for TinyMCE)
        
        form.find('textarea').each(function() {
            if (!$(this).hasClass('tinymce')) {
                var value = $(this).attr('value');
                if (value === undefined || value === null) {
                    value = $(this).attr('data-value');
                }
                $(this).val(value);
                $(this).trigger('autoresize');
            }
        });

        // Update height of columns
        $('main#content > .col').matchHeight();
    },

    goToStage2: function() {
        var form = $('#create-place');

        if ($('.stage-one').length < 1 && $('#create-place [name=formule]').val().length < 1) {
            $('#create-place').find('[name=formule]').val('partner');

            $('.stage-two').fadeIn();
            $('.section-actions .fake-submit').removeClass('disabled');
        }

        $('#place-type .choose').on('click', function() {
            var formule = $(this).data('type');

            $('#create-place').find('[name=formule]').val(formule);

            $('.stage-one').addClass('hidden');

            if (formule === 'simple') {
                $('.partner').addClass('hidden');
            } else if (formule === 'partner') {
                $('.partner:not(.organization):not(.individual)').removeClass('hidden');
            }  else {
                // Compagnie (for actor only)
                // more or less the same that "partner"

                var $selectCategory = $('select#category', form);
                var $selectSubCategory = $('select#subCategory', form);

                $('select#category > option').each(function() {
                    if (this.value == 127) {
                        // Scène
                        $(this).prop('selected', true);
                    } else {
                        if (this.value != '' || $(this).text() == 'Toutes') {
                            $(this).remove();
                        }
                    }
                });

                $selectCategory.trigger('change').formSelect();

                $('select#subCategory > option').each(function() {
                    if (this.value == 129 || this.value == 132 || this.value == 133) {
                        // Compagnies théâtrales / Compagnies d'improvisation / Compagnies de danse
                        $(this).prop('selected', true);
                    } else {
                        if (this.value != '' || $(this).text() == 'Toutes') {
                            $(this).remove();
                        }
                    }
                });

                $selectSubCategory.trigger('change').formSelect();

                $('.partner:not(.organization):not(.individual)').removeClass('hidden');
            }

            $('.stage-two').attr('data-formule', formule).fadeIn();

            // Update height of columns
            $('main#content > .col').matchHeight();
        });
    },

    updateFormFromSubcategories: function() {
        var $selectSubCategory = $('select#subCategory', $('#create-place'));

        $selectSubCategory.change(function() {
            if ($(this).val() != '') {

                var selectedValue = $(this).val();
                selectedValue = selectedValue;
                var isIndividual = false;

                for (var i = 0; i < places.onlyIndidivual.length; i++) {

                    if (places.onlyIndidivual[i] == selectedValue) {
                        isIndividual = true;
                    }
                }
            }

            if (isIndividual) {
                $('.individual:not(.partner)').removeClass('hidden');
                $('.organization').addClass('hidden'); 

                 $('.individual').find('.required').prop('required', true);           

                $('#create-place').find('[name=type]').val('individual');

            } else {
                $('.individual').addClass('hidden');
                $('.organization:not(.partner)').removeClass('hidden');

                $('.organization').find('.required').prop('required', true);

                $('#create-place').find('[name=type]').val('organization');
            } 

            var formule = $('[name=formule]').val();
            if (formule === 'simple') {
                $('.partner').addClass('hidden');
            } else {
                $('.partner').removeClass('hidden');
            }

            $('.section-actions .fake-submit').removeClass('disabled');

            // Update height of columns
            $('main#content > .col').matchHeight();
        });
    },

    submitForm: function() {
        var self = this;
        var form = $('#create-place');
        var btnSubmit = $('.section-actions .fake-submit');
        var spinner = $('.section-actions .preloader-wrapper');

        form.submit(function(e) {
            e.preventDefault();

            if (self.lockAjaxForm) {
                // Pending AJAX request... do nothing
                return;
            }

            self.lockAjaxForm = true;

            btnSubmit.addClass('disabled');
            spinner.css('display', 'inline-block').css('opacity', 1);
            $('.invalid', form).removeClass('invalid');

            var ajaxAction = 'dashboard.places.create';
            if (self.isUpdate) {
                ajaxAction = 'dashboard.places.update'
            }

            // Get HTML content from TinyMCE
            var description = tinymce.get('description').getContent();
            var individualdescription = tinymce.get('individualdescription').getContent();

            var formdata = false;
            if (window.FormData){
                formdata = new FormData(form[0]);

                formdata.append('action', ajaxAction);
                formdata.append('security', comedien.security);
                formdata.append('description', description);
                formdata.append('individualdescription', individualdescription);

                // Bug fix Safari 11 / Webkit
                // @link https://stackoverflow.com/questions/49614091/safari-11-1-ajax-xhr-form-submission-fails-when-inputtype-file-is-empty
                // @link https://trac.webkit.org/changeset/230963/webkit
                $("input[type=file]", form).each(function () {
                    if ($(this).val() === "") {
                        formdata.delete($(this).attr("name"));
                    }
                });
            }

            $.ajax({
                url: comedien.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: formdata ? formdata : form.serialize() + "&action=" + ajaxAction + "&security=" + comedien.security + "&description=" + description + "&individualdescription=" + individualdescription,
                contentType: false,
                processData: false,
                cache: false,
            }).done(function(response) {
                if (response.success) {
                    var redirectDelay = 5000;

                    if (self.isUpdate) {
                        M.toast({html: '<span>'+comedien.i18n.placeSuccessfullyUpdated+'</span>'}, redirectDelay);
                    } else {
                        redirectDelay = 10000;
                        $('#modal-dashboard-place-created').modal('open');
                    }

                    setTimeout(function() {
                        var url = $('#redirectTo', form).val();
                        location.replace(url);
                    }, redirectDelay);
                } else {
                    var nbErrors = Object.keys(response.data.errors).length;
                    if (nbErrors > 0) {
                        $.each(response.data.errors, function (i, item) {
                            $('#' + i, form).addClass('invalid');
                            M.toast({html:'<span>'+ item +'</span>'}, 5000);
                        });
                    } else {
                       M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                    }

                    btnSubmit.removeClass('disabled');
                }

                self.lockAjaxForm = false;
                spinner.css('opacity', 0).css('display', 'none');
            }).fail(function(jqXHR, textStatus) {
                self.lockAjaxForm = false;
                btnSubmit.removeClass('disabled');
                spinner.css('opacity', 0).css('display', 'none');
               M.toast({html: '<span>'+comedien.i18n.anErrorOccured+'</span>'}, 5000);
                console.log("Request failed: " + textStatus);
            });
        });

        btnSubmit.on('click', function() {
            if (self.isUpdate) {
                // Prepare hidden input for images order

                var idImages = '';
                $('section#images .row-images .col-image').each(function(index, element) {
                    idImages += $(this).data('attachment-id') + ',';
                });
                idImages = idImages.replace(/,\s*$/, "");
                $('#create-place #idImages').val(idImages);
            }

            // Pre-validate form
            var result = self.validateFormBeforeSubmit();

            if (result) {
                $('#create-place').submit();
            }
        });

        $('#modal-dashboard-place-created').modal({
            dismissible: false,
        });
    },

    /**
     * Validate the form before submit it.
     *
     * @returns {boolean}
     */
    validateFormBeforeSubmit: function() {
        return true;
    },

    dropdownCategories: function() {
        var $form = $('#create-place');
        var $selectCategory = $('select#category', $form);
        var $selectSubCategory = $('select#subCategory', $form);

        $selectCategory.change(function() {
            if ($(this).val() != '') {

                var selectedValue = $(this).val();
                
                // Remove all options
                $selectSubCategory.find('option').remove();
                $selectSubCategory.append($('<option>', {
                    value: '',
                    text : comedien.i18n.placesDropdownSubCategory,
                    disabled: 'disabled',
                    selected: 'selected',
                }));
                $selectSubCategory.append($('<option>', {
                    value: '',
                    text : comedien.i18n.placesDropdownAll
                }));

                // Inset new options
                $.each(places.subCategories, function (i, item) {
                    if (selectedValue == item.parent_id) {
                        $selectSubCategory.append($('<option>', {
                            value: item.term_id,
                            text : item.name
                        }));
                    }
                });
            } else {
                $selectSubCategory.find('option').remove();
                $selectSubCategory.append($('<option>', {
                    value: '',
                    text : comedien.i18n.placesDropdownSubCategory,
                    disabled: 'disabled',
                    selected: 'selected',
                }));
            }

            if ($(this).val() != '') {
                $selectSubCategory.removeAttr('disabled');
            } else {
                $selectSubCategory.attr('disabled', 'disabled');
            }

            $selectSubCategory.formSelect('destroy');
            $selectSubCategory.formSelect();
        });
    },

    deleteVideoChips: function() {
        $('.videos-box').on('click', '.close', function(event) {
            event.preventDefault();

            var value = $(this).parent().data('id')

            if ($('[name=deleteVideos]').val().length < 1) {
                var newValue = value;
            } else {
                var newValue = $('[name=deleteVideos]').val() + ','+ value;
            }

            $('[name=deleteVideos]').val(newValue)
        });
    },

    addVideoChips: function () {
        var videoChips = $('#create-place .video-chips');

        videoChips.on('chip.add', function (e, chip) {
            videoChips.find('.chip').prependTo(".videos-box");

            var oldValue = $('#create-place [name=videos]').val();
            if (oldValue.length < 1) {
                $('#create-place [name=videos]').val(chip.tag);
            } else {
                $('#create-place [name=videos]').val(oldValue +','+ chip.tag);
            }
        });

        // Keep the label active
        videoChips.find('input').on('change', function () {
            $(this).parents('.input-field').find('label').addClass('active');
        });

        // Add a chip when clicking on the Add button
        $('#create-place .adding-video').on('click', function (event) {
            event.preventDefault()

            // Create and add the chip
            var newChip = videoChips.find('input').val();
            $(".videos-box").append('<div class="chip">' + newChip + '<i class="material-icons close">close</i></div>');

            var oldValue = $('#create-place [name=videos]').val();
            if (oldValue.length < 1) {
                $('#create-place [name=videos]').val(newChip);
            } else {
                $('#create-place [name=videos]').val(oldValue +','+ newChip);
            }

            // Clean the input
            videoChips.find('input').val('');

            // Remove active class
            videoChips.find('input').parents('.input-field').find('label').removeClass('active');
        });
    },

    deletePictures: function() {
        $('.picture .delete-picture').on('click', function(event) {
            event.preventDefault();

            if ($(this).parents('.picture').hasClass('featured')) {
                 var value = 'featured';
            } else {
                var value = $(this).parents('.picture').data('id');
            }

            $(this).parents('.picture-content').remove();
            
            if ($('[name=deletePictures]').val().length < 1) {
                var newValue = value;
            } else {
                var newValue = $('[name=deletePictures]').val() + ','+ value;
            }
            $('[name=deletePictures]').val(newValue);
        });
    },

};

module.exports = new FrontPlacesDashboard();
